import { SubscriptionStore, ELYXCentralStore } from "../ELYXStore";
import { SharedSessionConstants } from "@shared";
import SubscriptionMethods from "../Subscriptions/SubscriptionMethods";
import ELYXConstants from "../ELYXConstants";
const BOOKING_STATUS_CODES = SharedSessionConstants.BOOKING_STATUS_CODES;
import CalendarConstants from "./CalendarConstants";

const CalendarUtilities = {
  displayBookingRestrictionModal(bookingStatusCode) {
    const bookingLimitExceededCodes = [
      BOOKING_STATUS_CODES.BOOKING_DISABLED,
      BOOKING_STATUS_CODES.BOOKING_SUSPENDED_BY_ADMIN,
      BOOKING_STATUS_CODES.BOOKING_SUSPENDED_CANCELLATION_ABUSE,
      BOOKING_STATUS_CODES.BOOKING_ABOVE_LIMIT,
      BOOKING_STATUS_CODES.FIRST_SESSION_LIMIT,
    ];

    const freeSessionLimitExceededCodes = [BOOKING_STATUS_CODES.FREE_SESSIONS_USED, BOOKING_STATUS_CODES.BOOKING_ABOVE_FREE_LIMIT];

    if (bookingLimitExceededCodes.includes(bookingStatusCode)) {
      ELYXCentralStore.methods.setModal(ELYXConstants.modals.CalendarBookingRestrictionModal);
    } else if (bookingStatusCode === BOOKING_STATUS_CODES.BOOKING_FROZEN) {
      ELYXCentralStore.methods.setModal(ELYXConstants.modals.CalendarBookingFrozenModal);
    } else if (freeSessionLimitExceededCodes.includes(bookingStatusCode)) {
      /** @NB We do not cancel their selection as it may contain a few sessions they CAN book,
       * rather user can cancel or upgrade to book more. */
      SubscriptionStore.methods.setReachedMaxFreeSessions(true);
      SubscriptionMethods.openSubscriptionModal("Reaching Free Session Limit");
    }
  },

  async getSessionNotificationSound(soundNumber) {
    return await CalendarConstants.SESSION_NOTIFICATION_SOUNDS[soundNumber]();
  },
};

export default CalendarUtilities;
